// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ZDr8","amount":"Amount_amount__2HZoI","tip":"Amount_tip__1ks0w","tipHeader":"Amount_tipHeader__2qbUy","tipsWrap":"Amount_tipsWrap__2dJOT"};